import { render } from "./Services.vue?vue&type=template&id=a6b83fec&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=a6b83fec&scoped=true&lang=css"

import exportComponent from "/builds/tapetum1/tapetum-landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6b83fec"]])

export default __exports__